import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SliderListItem from '../../../../../list-items/SliderListItem';

const TextDriftAmplitudeXListItem = (props) => {
    const { amplitudeX, index, updateTextElement } = props;

    const onAmplitudeXChange = (value) => updateTextElement(index, { drift: { amplitudeX: value } });

    return (
        <SliderListItem
            title='X Distance'
            displayMultiplier={2}
            value={amplitudeX}
            min={0}
            max={100}
            step={1}
            onValueChange={onAmplitudeXChange}
            toolTip='Horizontal movement distance.'
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const { amplitudeX } = state.createPreview.present.videoSettings.text.textElements[ownProps.index].drift;
    return { amplitudeX };
};

const mapDispatchToProps = (dispatch) => {
    const updateTextElement = (index, properties) => dispatch(createActions.updateTextElement(index, properties));
    return { updateTextElement };
};

export default connect(mapStateToProps, mapDispatchToProps)(TextDriftAmplitudeXListItem);
